// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".setting-fab[data-v-7ba5bd90] {\n  top: 50% !important;\n  right: 0;\n  border-radius: 0;\n}", ""]);
// Exports
module.exports = exports;
